<section class="page-with-tabs">
  <!-- Page Header -->
  <div class="page-title">
    <ng-container>
      <div style="height: 23px; overflow: visible">
        <a mat-icon-button (click)="back()">
          <mat-icon>arrow_back</mat-icon>
        </a>
        <h2 class="d-inline-block">
          {{ 'Communications.CommunicationsHistoryTitle' | translate }}
        </h2>
      </div>
    </ng-container>
  </div>

  <!-- Page Body -->
  <div class="container m-4">
    <div class="row">
      <div class="col">
        <mat-card>
          <mat-card-content>
            <mat-progress-bar
              mode="query"
              color="primary"
              *ngIf="isLoading; else loaded"
            >
            </mat-progress-bar>
            <ng-template #loaded>
              <div *ngIf="communications.length; else noData">
                <!-- Headers -->
                <div class="communication-list headers">
                  <div>{{ 'Communications.Title' | translate }}</div>
                  <div>{{ 'Communications.PublishDate' | translate }}</div>
                  <div>{{ 'Communications.ExpiryDate' | translate }}</div>
                </div>

                <!-- List Communications -->
                <div
                  class="communication-list"
                  *ngFor="let comm of communications"
                  (click)="selectCommunication(comm)"
                >
                  <div>
                    <a [title]="comm.englishTitle" class="text-primary">
                      <img
                        class="nav-icon material-icons"
                        style="width: 24px; margin: 4px"
                        src="assets/images/campaign.svg"
                      />
                      <span *ngIf="localeService.getLocale() == 'en-CA'">{{
                        comm.englishTitle
                      }}</span>
                      <span *ngIf="localeService.getLocale() == 'fr-CA'">{{
                        comm.frenchTitle
                      }}</span>
                    </a>
                  </div>
                  <div>
                    {{ comm.publishDate | kortoDate }}
                  </div>
                  <div>
                    {{ comm.expiryDate | kortoDate }}
                  </div>
                </div>
              </div>

              <!-- No Data Message -->
              <ng-template #noData>{{
                'Communications.NoCommunications' | translate
              }}</ng-template>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>
</section>
